import React, { useState } from "react";
import styles from "./styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

import {
  Button,
  ClickAwayListener,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";
import ReactHtmlParser from "react-html-parser";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import imageDrSalud from "../../../assets/cards/drsalud.png";
import imageMedico from "../../../assets/cards/medico.png";
import imageHospital from "../../../assets/cards/hospital.png";
import imageMedicinas from "../../../assets/cards/medicinas.png";
import imageExamenes from "../../../assets/cards/examenes.png";
import imageHomecare from "../../../assets/cards/homecare.png";
import imageDrsaludMegaMenu from "../../../assets/images/am_drsalud_mega_menu.png";
import imageNeedDrMegaMenu from "../../../assets/images/am_medico_mega_menu.jpg";
import imageNeedHospitalizationMegaMenu from "../../../assets/images/am_hospitalizacion_mega_menu.jpg";
import imageNeedMedicalExamsMegaMenu from "../../../assets/images/am_examenes_mega_menu.jpg";
import imageHomeServicesMegaMenu from "../../../assets/images/am_homecare_mega_menu.jpg";
import imageEvaluadorMegaMenu from "../../../assets/images/evaluador_sintomas.png";

const listPlans = [
  {
    id: 1,
    name: "¿Que es DrSalud?",
    title: "¿Qué es DrSalud?",
    image: imageDrSalud,
    description:
      "Es un servicio 24/7 exclusivo de Saludsa en donde recibes asesoramiento para encontrar y acceder al prestador médico más adecuado para ti.",
    url: "/drsalud/",
    type: "banner",
    link: true,
    children: [
      {
        title: "Guía médica",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://guia.drsalud.com/#/guiaMedica",
        link: true
      },

      {
        title: "Centro de ayuda",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://serviciosaludsa.zendesk.com/hc/es",
        backgroundC: "color-light-blue",
        link: true
      },
      {
        title: "Cerotrámites",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/cero-tramites-2/"
      },
      {
        title: "Descarga la App",
        description: "Conoce el costo de tus prestaciones médicas",
        url: "https://onelink.to/9fxba5",
        backgroundC: "color-transparent",
        link: true
      },
      {
        title: "Call center",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "tel:6020920",
        link: true
      }
    ]
  },
  {
    id: 2,
    name: "¿Quieres evaluar tus síntomas?",
    title: "¿Quieres evaluar tus síntomas?",
    image: imageDrSalud,
    description:
      "Es un servicio 24/7 exclusivo de Saludsa en donde recibes asesoramiento para encontrar y acceder al prestador médico más adecuado para ti.",
    url: "/drsalud/",
    type: "banner",
    link: true,
    children: []
  },

  {
    id: 3,
    name: "¿Necesitas un médico?",
    title:
      '<div>¿Necesitas</div><div>un Médico?</div><div style="font-size: 12px;">DrSalud</div>',
    image: imageMedico,
    description:
      "El servicio de DrSalud te pertime acceder a médicos según tu requerimiento. Escoge una de las siguientes opciones:",
    type: "banner",
    link: true,
    children: [
      {
        title: "Consulta médica en línea",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/consulta_medica_en_linea/"
      },
      {
        title: "Guía médica",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://guia.drsalud.com/#/guiaMedica",
        link: true
      },

      {
        title: "Médico a domicilio",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://guia.drsalud.com/#/atencionesMedicas#medicoDomicilio",
        link: true
      },

      {
        title: "Segunda opinión médica",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/segunda-opinion-medica/"
      },

      {
        title: "ODA consulta",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/oda/"
      },

      {
        title: "Centro de ayuda",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://serviciosaludsa.zendesk.com/hc/es",
        backgroundC: "color-light-blue",
        link: true
      },
      {
        title: "Agendar cita médica en línea",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/consulta_medica_en_linea/"
      },
      {
        title: "Descarga la App",
        description: "Conoce el costo de tus prestaciones médicas",
        url: "https://onelink.to/9fxba5",
        backgroundC: "color-transparent",
        link: true
      }
    ]
  },
  {
    id: 4,
    name: "¿Necesitas una hospitalización?",
    title:
      '<div>¿Necesitas una</div><div>hospitalización?</div><div style="font-size: 12px;">DrSalud</div>',
    image: imageHospital,
    description:
      "Cómo quisieras coordinar tu hospitalización con un asesor de DrSalud. Escoge una de las siguientes opciones:",
    type: "banner",
    link: true,
    children: [
      {
        title: "Chat",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url:
          "https://servicios.saludsa.com.ec/ChatGenesis/informacion.html?x=76&y=10",
        link: true
      },
      {
        title: "Estimador de valores",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/estimador-de-valores/"
      },
      {
        title: "Videoconsulta",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/consulta_medica_en_linea/"
      },
      {
        title: "Solicitud de cobertura hospitalaria en línea",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url:
          "https://serviciosaludsa.zendesk.com/hc/es/articles/360035875792-Solicitud-de-Cobertura-en-L%C3%ADnea",
        link: true
      },
      {
        title: "Call center",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "tel:6020920",
        link: true
      },
      {
        title: "Centro de ayuda",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://serviciosaludsa.zendesk.com/hc/es",
        backgroundC: "color-light-blue",
        link: true
      },
      {
        title: "Guía médica",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://guia.drsalud.com/#/guiaMedica",
        link: true
      },

      {
        title: "Descarga la App",
        description: "Conoce el costo de tus prestaciones médicas",
        url: "https://onelink.to/9fxba5",
        backgroundC: "color-transparent",
        link: true
      }
    ]
  },
  {
    id: 5,
    name: "¿Necesitas medicinas?",
    title:
      '<div>¿Necesitas</div><div>medicinas?</div><div style="font-size: 12px;">DrSalud</div>',
    image: imageMedicinas,
    description:
      "Cómo quisieras coordinar tus medicinas con un asesor de DrSalud. Escoge una de las siguientes opciones:",
    type: "banner",
    link: true,
    children: [
      {
        title: "Medicinas a domicilio (HomeCare)",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/home_care/"
      },

      {
        title: "Centro de ayuda",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://serviciosaludsa.zendesk.com/hc/es",
        backgroundC: "color-light-blue",
        link: true
      },

      {
        title: "Farmacias",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://guia.drsalud.com/#/buscador/farmacia",
        link: true
      },
      {
        title: "Descarga la App",
        description: "Conoce el costo de tus prestaciones médicas",
        url: "https://onelink.to/9fxba5",
        backgroundC: "color-transparent",
        link: true
      },
      {
        title: "Call center",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "tel:6020920",
        link: true
      }
    ]
  },
  {
    id: 6,
    name: "¿Necesitas exámenes médicos?",
    title:
      '<div>¿Necesitas</div><div>exámenes</div><div>médicos?</div><div style="font-size: 12px;">DrSalud</div>',
    image: imageExamenes,
    description:
      "Cómo quisieras coordinar tus medicinas con un asesor de DrSalud. Escoge una de las siguientes opciones:",
    type: "banner",
    link: true,
    children: [
      {
        title: "Exámenes a domicilio (HomeCare)",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/home_care/"
      },
      {
        title: "Call center",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "tel:6020920",
        link: true
      },
      {
        title: "Laboratorios clínicos",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://guia.drsalud.com/#/buscador/laboratorioClinico",
        link: true
      },
      {
        title: "Centro de ayuda",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://serviciosaludsa.zendesk.com/hc/es",
        backgroundC: "color-light-blue",
        link: true
      },

      {
        title: "Laboratorios de imágen",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://guia.drsalud.com/#/buscador/laboratorioImagen",
        link: true
      },
      {
        title: "Descarga la App",
        description: "Conoce el costo de tus prestaciones médicas",
        url: "https://onelink.to/9fxba5",
        backgroundC: "color-transparent",
        link: true
      }
    ]
  },
  // {
  //   id: 6,
  //   name: "¿Necesitas terapias?",
  //   title:
  //     '<div>¿Necesitas</div><div>terapias?</div><div style="font-size: 12px;">DrSalud</div>',
  //   image: imageMedicinas,
  //   description:
  //     "Cómo quisieras coordinar tus terapias con un asesor de DrSalud. Escoge una de las siguientes opciones:",
  //   type: "banner",
  //   link: true,
  //   children: [
  //     {
  //       title: "Terapias a domicilio (HomeCare)",
  //       description:
  //         "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
  //       url: "/home_care/"
  //     },

  //     {
  //       title: "Centro de ayuda",
  //       description:
  //         "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
  //       url: "https://serviciosaludsa.zendesk.com/hc/es",
  //       backgroundC: "color-light-blue",
  //       link: true
  //     },

  //     {
  //       title: "Centros de terapia",
  //       description:
  //         "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
  //       url: "https://guia.drsalud.com/#/buscador/centroTerapia",
  //       link: true
  //     },
  //     {
  //       title: "Descarga la App",
  //       description: "Conoce el costo de tus prestaciones médicas",
  //       url: "https://onelink.to/9fxba5",
  //       backgroundC: "color-transparent",
  //       link: true
  //     },
  //     {
  //       title: "Call center",
  //       description:
  //         "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
  //       url: "tel:6020920",
  //       link: true
  //     }
  //   ]
  // },
  {
    id: 7,
    name: "Servicios médicos a domicilio HomeCare",
    title: '<div>HomeCare</div><div style="font-size: 12px;">DrSalud</div>',
    image: imageHomecare,
    description:
      "Cómo quisieras coordinar tus servicios médicos a domicilio con DrSalud. Escoge una de las siguientes opciones:",
    type: "banner",
    link: true,
    children: [
      {
        title: "HomeCare",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/home_care/"
      },
      {
        title: "Laboratorio clínico e imagen",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://guia.drsalud.com/#/buscador/laboratorioClinico",
        link: true
      },
      {
        title: "Consulta médica en línea",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/consulta_medica_en_linea/"
      },
      {
        title: "Medicina a domicilio",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "/home_care/"
      },
      {
        title: "Servicio de enfermería a domicilio",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://guia.drsalud.com/#/buscador/busquedaGeneral/Enfermeria",
        link: true
      },
      {
        title: "Centro de ayuda",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://serviciosaludsa.zendesk.com/hc/es",
        backgroundC: "color-light-blue",
        link: true
      },
      {
        title: "Médico a domicilio",
        description:
          "Olvidate de los Rembolsos y solo paga un valor mínimo en tus prestaciones",
        url: "https://guia.drsalud.com/#/atencionesMedicas#medicoDomicilio",
        link: true
      },

      {
        title: "Descarga la App",
        description: "Conoce el costo de tus prestaciones médicas",
        url: "https://onelink.to/9fxba5",
        backgroundC: "color-transparent",
        link: true
      }
    ]
  }
];
export const MedicalAssistencePlans = ({ handleClickAway, visible }) => {
  const classes = styles();
  const [selectedPlan, setSelectedPlan] = useState(1);
  const handleListItemClick = (event, index) => {
    setSelectedPlan(index);
  };

  const tabDrSalud = () => {
    return (
      <div className={classes.amMainContainerMegaMenu}>
        <div
          className={classes.amContainerHeaderMegaMenu}
          style={{
            backgroundImage: `url(${imageDrsaludMegaMenu})`
          }}
        >
          <div className={classes.amHeaderMegaMenu}>
            <div className={classes.tituloContenedorCoberturaMegaMenu}>
              ¿Qué es DrSalud?
            </div>
            <div
              className={classes.subtituloContenedorCoberturaMegaMenu}
              style={{ maxWidth: "420px" }}
            >
              Es un servicio 24/7 exclusivo de Saludsa en donde recibes
              asesoramiento para encontrar y acceder al prestador médico más
              adecuado para ti.
            </div>
          </div>
        </div>
        <div className={classes.amDescriptionMegaMenu}>
          <div
            className={classes.amContenedoresMegaMenu}
            style={{ marginRight: 0 }}
          >
            <div
              className={classes.tituloDescripcionAmMegaMenu}
              style={{ marginBottom: "10px" }}
            >
              ¿Como accedo a DrSalud?
            </div>
            <a
              href="/drsalud/"
              className={`${classes.tituloDescripcionAmMegaMenu} ${classes.amNormalMarginMegaMenu}`}
            >
              DrSalud
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=+593939874000&text=Hola,%20soy%20cliente%20de%20Saludsa,%20necesito%20asesor%C3%ADa%20m%C3%A9dica.%3C!--%20[et_pb_line_break_holder]%20--%3E"
              className={`${classes.tituloDescripcionAmMegaMenu} ${classes.amNormalMarginMegaMenu}`}
            >
              WhatsApp
            </a>
            <a
              href="https://www.saludsapersonas.com/portalclientes/Account/Login"
              className={`${classes.tituloDescripcionAmMegaMenu} ${classes.amNormalMarginMegaMenu}`}
            >
              Portal de clientes
            </a>
            <a
              href="/contactos/#contact-center"
              className={`${classes.tituloDescripcionAmMegaMenu} ${classes.amNormalMarginMegaMenu}`}
            >
              Contact Center
            </a>
          </div>
          <div className={classes.lineaDivisorCanalesServicios}></div>
          <a
            href="http://guia.drsalud.com/#/guiaMedica"
            className={classes.linkAmMegaMenu}
            style={{
              marginBottom: 0,
              maxWidth: "220px",
              marginRight: "10px",
              height: "fit-content"
            }}
          >
            <div className={classes.tituloDescripcionAmMegaMenu}>
              Guía médica red Saludsa
            </div>
            <div className={classes.descripcionTarjetaAsistenciaMedica}>
              Conoce la red de prestadores médicos de prestigio afiliados a
              Saludsa.
            </div>
          </a>
          <div className={classes.amContenedoresMegaMenu}>
            <a
              href="https://serviciosaludsa.zendesk.com/hc/es"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuCeleste}`}
            >
              Centro de ayuda
            </a>
            <a
              href="http://onelink.to/ag439w"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuMorado}`}
            >
              Descarga la App
            </a>
            <div
              className={`${classes.descripcionTarjetaAsistenciaMedica} ${classes.condicionesTextAmMegaMenu}`}
            >
              *Aplican condiciones según el plan contratado
            </div>
          </div>
        </div>
      </div>
    );
  };

  const tabEvaluador = () => {
    return (
      <div className={classes.planMenuContainer}>
        <div
          className={classes.coberturaEcuadorMegaMenu}
          style={{
            backgroundImage: `url(${imageEvaluadorMegaMenu})`,
            minHeight: "260px",
            borderBottomRightRadius: "7px"
          }}
        >
          <div
            className={`${classes.megaMenuMedicaMundial} ${classes.megaMenuCoberturaFrenteCancer}`}
          >
            <div className={classes.tituloMegaMenuOncocare}>
              Evaluador de síntomas
            </div>
            <div className={classes.subtituloContenedorCoberturaMegaMenu}>
              <span style={{ fontWeight: "bold" }}>Saludsa</span>, junto a la
              startup
              <span style={{ fontWeight: "bold" }}>Mediktor</span>,
              desarrollamos un asistente virtual con AI para evaluar los
              síntomas de los usuarios y determinar el nivel de atención y
              especialidad médica más adecuada.
            </div>
            <a
              href="/evaluador-sintomas/"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.botonesCoberturaFrenteCancerMegaMenu}`}
            >
              Conoce más
            </a>
          </div>
        </div>
      </div>
    );
  };

  const tabNeedDr = () => {
    return (
      <div className={classes.amMainContainerMegaMenu}>
        <div
          className={classes.amContainerHeaderMegaMenu}
          style={{
            backgroundImage: `url(${imageNeedDrMegaMenu})`
          }}
        >
          <div className={classes.amHeaderMegaMenu}>
            <div className={classes.tituloContenedorCoberturaMegaMenu}>
              ¿Necesitas un Médico?
            </div>
            <div
              className={classes.subtituloContenedorCoberturaMegaMenu}
              style={{ maxWidth: "420px" }}
            >
              Te asesoramos y coordinamos tu atención con médicos de prestigio.
              Escoge el tipo de consulta más conveniente para ti.
            </div>
          </div>
        </div>

        <div className={classes.amDescriptionMegaMenu}>
          <div className={classes.amContenedoresMegaMenu}>
            <a
              href="/consulta-medica-en-linea/"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Consulta médica en línea
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Sin costo y desde comodidad de tu hogar accede a cientos de
                profesionales en línea.
              </div>
            </a>
            <a href="/medico-a-domicilio/" className={classes.linkAmMegaMenu}>
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Médico a domicilio
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Coordina con nosotros y en pocas horas recibe la visita de un
                médico en tu domicilio
              </div>
            </a>
            <a
              href="http://onelink.to/ag439w"
              className={classes.linkAmMegaMenu}
              style={{ marginBottom: 0 }}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Agendamiento de citas
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Agendar tu cita el línea con doctores de los principales centros
                médicos del país.
              </div>
            </a>
          </div>
          <div className={classes.amContenedoresMegaMenu}>
            <a href="/home_servicios/oda/" className={classes.linkAmMegaMenu}>
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Solicita tu ODA
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Para acceder a médicos de prestigio de la red Saludsa realizando
                solo un pago mínimo
              </div>
            </a>
            <a
              href="/segunda-opinion-medica/"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Segunda opnión médica{" "}
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Coordina un segunda opinión con médicos de prestigio de la
                Clínica Universidad de Navarra
              </div>
            </a>
          </div>
          <div
            className={classes.amContenedoresMegaMenu}
            style={{ marginRight: 0 }}
          >
            <a
              href="https://serviciosaludsa.zendesk.com/hc/es"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuCeleste}`}
            >
              Centro de ayuda
            </a>
            <a
              href="http://onelink.to/ag439w"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuMorado}`}
            >
              Descarga la App
            </a>
            <div
              className={`${classes.descripcionTarjetaAsistenciaMedica} ${classes.condicionesTextAmMegaMenu}`}
            >
              *Aplican condiciones según el plan contratado
            </div>
          </div>
        </div>
      </div>
    );
  };

  const tabNeedHospitalization = () => {
    return (
      <div className={classes.amMainContainerMegaMenu}>
        <div
          className={classes.amContainerHeaderMegaMenu}
          style={{
            backgroundImage: `url(${imageNeedHospitalizationMegaMenu})`
          }}
        >
          <div className={classes.amHeaderMegaMenu}>
            <div className={classes.tituloContenedorCoberturaMegaMenu}>
              ¿Necesitas una hospitalización?
            </div>
            <div
              className={classes.subtituloContenedorCoberturaMegaMenu}
              style={{ maxWidth: "420px" }}
            >
              El equipo de DrSalud esta disponible 24/7 para coordinar tu
              hospitalización. Te presentamos la siguientes opciones:
            </div>
          </div>
        </div>
        <div className={classes.amDescriptionMegaMenu}>
          <div className={classes.amContenedoresMegaMenu}>
            <a
              href="https://serviciosaludsa.zendesk.com/hc/es/articles/360035875792-Solicitud-de-Cobertura-en-L%C3%ADnea"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Solicitud de cobertura hospitalaria en linea
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                En pocos minutos completa tu solicitud y nos contactaremos
                contigo para pre autorizar tu hospitalización
              </div>
            </a>
            <a
              href="https://apps.saludsa.com/calculadorprocedimientos/?__hstc=213659531.f1a25314a93e8960690d4f87c24f8f56.1620657222726.1620667209654.1620672653676.4&__hssc=213659531.6.1620672653676&__hsfp=3955714536"
              className={`${classes.tituloDescripcionAmMegaMenu} ${classes.amNormalMarginMegaMenu}`}
              style={{ marginTop: "30px" }}
            >
              Consultar tarifario
            </a>
          </div>
          <div className={classes.amContenedoresMegaMenu}>
            <a
              href="https://saludsa.instasalud.com/saludsa"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Asesoría hospitalaria (Videollamada)
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Agenda una cita con un especialista para coordinar tu
                hospitalización
              </div>
            </a>
          </div>
          <div
            className={classes.amContenedoresMegaMenu}
            style={{ marginRight: 0 }}
          >
            <a
              href="https://serviciosaludsa.zendesk.com/hc/es"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuCeleste}`}
            >
              Centro de ayuda
            </a>
            <a
              href="http://onelink.to/ag439w"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuMorado}`}
            >
              Descarga la App
            </a>
            <div
              className={`${classes.descripcionTarjetaAsistenciaMedica} ${classes.condicionesTextAmMegaMenu}`}
            >
              *Aplican condiciones según el plan contratado
            </div>
          </div>
        </div>
      </div>
    );
  };

  const tabNeedMedicines = () => {
    return (
      <div className={classes.amMainContainerMegaMenu}>
        <div
          className={classes.amContainerHeaderMegaMenu}
          style={{
            backgroundImage: `url(${imageNeedHospitalizationMegaMenu})`
          }}
        >
          <div className={classes.amHeaderMegaMenu}>
            <div className={classes.tituloContenedorCoberturaMegaMenu}>
              ¿Necesitas una medicinas?
            </div>
            <div
              className={classes.subtituloContenedorCoberturaMegaMenu}
              style={{ maxWidth: "420px" }}
            >
              En DrSaludsa facilitamos la compra de tus medicinas. Selecciona la
              opción más conveniente
            </div>
          </div>
        </div>
        <div className={classes.amDescriptionMegaMenu}>
          <div className={classes.amContenedoresMegaMenu}>
            <a
              href="http://onelink.to/ag439w"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Medicinas cero trámites
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                En farmacias afiliadas solo paga un valor mínimo (copago) para
                acceder a medicinas.
              </div>
            </a>
            <a
              href="https://www.saludsapersonas.com/portalclientes/Oda/SelectBeneficiaryForMedicationCredit?param=FAR"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Medicinas a domicilio
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Coordina con DrSalud la entrega de medicinas a domicilio pagando
                solo un valor mínimo (copago)
              </div>
            </a>
          </div>
          <div
            className={classes.amContenedoresMegaMenu}
            style={{ marginRight: 0 }}
          >
            <a
              href="https://serviciosaludsa.zendesk.com/hc/es"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuCeleste}`}
            >
              Centro de ayuda
            </a>
            <a
              href="http://onelink.to/ag439w"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuMorado}`}
            >
              Descarga la App
            </a>
            <div
              className={`${classes.descripcionTarjetaAsistenciaMedica} ${classes.condicionesTextAmMegaMenu}`}
            >
              *Aplican condiciones según el plan contratado
            </div>
          </div>
        </div>
      </div>
    );
  };

  const tabMedicalExams = () => {
    return (
      <div className={classes.amMainContainerMegaMenu}>
        <div
          className={classes.amContainerHeaderMegaMenu}
          style={{
            backgroundImage: `url(${imageNeedMedicalExamsMegaMenu})`
          }}
        >
          <div className={classes.amHeaderMegaMenu}>
            <div className={classes.tituloContenedorCoberturaMegaMenu}>
              Exámenes a domicilio (Homecare)
            </div>
            <div
              className={classes.subtituloContenedorCoberturaMegaMenu}
              style={{ maxWidth: "420px" }}
            >
              En DrSalud facilitamos el acceso a tus exámenes médicos.
              Selecciona la opción más conveniente
            </div>
          </div>
        </div>
        <div className={classes.amDescriptionMegaMenu}>
          <div className={classes.amContenedoresMegaMenu}>
            <a
              href="https://www.saludsapersonas.com/portalclientes/Homecare/HomecareStep"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Exámenes a domicilio (Homecare)
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Coordina con DrSalud exámenes de laboratorio a domicilio pagando
                solo un valor mínimo (copago)
              </div>
            </a>
            <a
              href="http://onelink.to/ag439w"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Exámenes de laboratorio e imagen cero trámites
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                En centros médicos afiliados solo paga un valor mínimo (copago)
                para acceder a exámenes.
              </div>
            </a>
          </div>
          <div
            className={classes.amContenedoresMegaMenu}
            style={{ marginRight: 0 }}
          >
            <a
              href="https://serviciosaludsa.zendesk.com/hc/es"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuCeleste}`}
            >
              Centro de ayuda
            </a>
            <a
              href="http://onelink.to/ag439w"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuMorado}`}
            >
              Descarga la App
            </a>
            <div
              className={`${classes.descripcionTarjetaAsistenciaMedica} ${classes.condicionesTextAmMegaMenu}`}
            >
              *Aplican condiciones según el plan contratado
            </div>
          </div>
        </div>
      </div>
    );
  };

  const tabHomeServices = () => {
    return (
      <div className={classes.amMainContainerMegaMenu}>
        <div
          className={classes.amContainerHeaderMegaMenu}
          style={{
            backgroundImage: `url(${imageHomeServicesMegaMenu})`
          }}
        >
          <div className={classes.amHeaderMegaMenu}>
            <div className={classes.tituloContenedorCoberturaMegaMenu}>
              HomeCare
            </div>
            <div
              className={classes.subtituloContenedorCoberturaMegaMenu}
              style={{ maxWidth: "420px" }}
            >
              Conocemos lo importante que es recibir atención medica en casa.
              Por eso creamos nuestro servicio HomeCare
            </div>
          </div>
        </div>

        <div className={classes.amDescriptionMegaMenu}>
          <div className={classes.amContenedoresMegaMenu}>
            <a
              href="https://serviciosaludsa.zendesk.com/hc/es/articles/360050891311--Qu%C3%A9-es-el-servicio-Home-Care-"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                HomeCare
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Conoce al detalle nuestro servicio a domicilio HomeCare
              </div>
            </a>
            <a
              href="https://saludsa.instasalud.com/saludsa"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Consulta médica en línea
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Sin costo y desde comodidad de tu hogar accede a cientos de
                profesionales en línea.
              </div>
            </a>
            <a
              href="https://www.saludsapersonas.com/portalclientes/Oda/SelectBeneficiaryForMedicationCredit?param=FAR"
              className={classes.linkAmMegaMenu}
              style={{ marginBottom: 0 }}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Medicina a domicilio
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Entrega de medicinas a domicilio pagando solo un valor mínimo
                (copago)
              </div>
            </a>
          </div>
          <div className={classes.amContenedoresMegaMenu}>
            <a
              href="https://www.saludsapersonas.com/portalclientes/Homecare/HomecareStep"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Laboratorio clínico e imagen
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                En DrSalud coordinamos tus exámenes a domicilio, pagando un
                valor mínimo.
              </div>
            </a>
            <a
              href="https://www.saludsapersonas.com/portalclientes/Homecare/HomecareStep"
              className={classes.linkAmMegaMenu}
            >
              <div className={classes.tituloDescripcionAmMegaMenu}>
                Enfermería a domicilio
              </div>
              <div className={classes.descripcionTarjetaAsistenciaMedica}>
                Accede a los servicios de enfermería en casa, nosotros los
                coordinamos por ti.
              </div>
            </a>
          </div>
          <div
            className={classes.amContenedoresMegaMenu}
            style={{ marginRight: 0 }}
          >
            <a
              href="https://serviciosaludsa.zendesk.com/hc/es"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuCeleste}`}
            >
              Centro de ayuda
            </a>
            <a
              href="http://onelink.to/ag439w"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.amBotonMegaMenuMorado}`}
            >
              Descarga la App
            </a>
            <div
              className={`${classes.descripcionTarjetaAsistenciaMedica} ${classes.condicionesTextAmMegaMenu}`}
            >
              *Aplican condiciones según el plan contratado
            </div>
          </div>
        </div>
      </div>
    );
  };

  const cardTabsGeneral = plan => {
    return (
      <div className={classes.planMenuContainer}>
        <div className={classes.headermenuAsistenciaMedica}>
          <div className={classes.imagenmenuAsistenciaMedica}>
            <img
              src={plan?.image}
              alt={plan?.title}
              className={classes.bannerImage}
            />
            {/* <img src="/wp-content/uploads/2021/02/drsalud.png" /> */}
            <div className={classes.textoimgmenuAsistenciaMedica}>
              {ReactHtmlParser(plan?.title)}
            </div>
          </div>
          <div className={classes.descripcionHeadermenuasistenciaMedica}>
            {ReactHtmlParser(plan?.description)}
          </div>
        </div>

        <div className={classes.cardContainer}>
          {plan &&
            plan.children?.map((item, index) => (
              <Link
                href={
                  item.link
                    ? item.url
                    : `${process.env.REACT_APP_URL_HOST}${item.url}`
                }
                key={index}
                className={`${classes.cardMedicalAssistenceContainer} ${item.backgroundC}`}
              >
                <div className={classes.titleMedicalAssistence}>
                  {item.title}
                </div>
                <div className={classes.descriptionMedicalAssistence}>
                  {ReactHtmlParser(item?.description)}
                </div>
                <div className={classes.arrowContainer}>
                  <span className={`${classes.arrowIcon} ${classes.colorGris}`}>
                    <ArrowForwardIosIcon className={classes.iconSize} />
                  </span>
                </div>
              </Link>
            ))}
        </div>
      </div>
    );
  };

  const card = () => {
    const plan = listPlans.find(p => p.id === selectedPlan);

    switch (selectedPlan) {
      case 1:
        return tabDrSalud();
      case 2:
        return tabEvaluador();
      case 3:
        return tabNeedDr();
      case 4:
        return tabNeedHospitalization();
      case 5:
        return tabNeedMedicines();
      case 6:
        return tabMedicalExams();
      case 7:
        return tabHomeServices();
      default:
        return "";
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Grid
        container
        className={classes.absoluteSContainer}
        style={{ display: visible ? "flex" : "none" }}
      >
        <Grid
          container
          justify="flex-end"
          style={{ width: "290px", maxWidth: "290px" }}
        >
          <div className={classes.listContainer}>
            <List
              component="nav"
              aria-label="Lista de planes"
              className={classes.navContainer}
            >
              {listPlans.map(item => (
                <ListItem
                  button
                  key={item.id}
                  selected={selectedPlan === item.id}
                  onClick={event => handleListItemClick(event, item.id)}
                  className={classes.itemMenu}
                >
                  <ListItemText
                    className={classes.textItem}
                    primary={item.name}
                  />
                  {selectedPlan === item.id ? (
                    <ListItemIcon style={{ display: "contents" }}>
                      <ArrowForwardIosIcon className={classes.iconActive} />
                    </ListItemIcon>
                  ) : (
                    ""
                  )}
                </ListItem>
              ))}
            </List>
          </div>
        </Grid>
        <Grid style={{ width: "670px", maxWidth: "670px" }}>{card()}</Grid>
      </Grid>
    </ClickAwayListener>
  );
};

MedicalAssistencePlans.propTypes = {
  handleClickAway: PropTypes.any,
  visible: PropTypes.any
};
